import React from 'react';
import { useForm } from 'react-hook-form';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import style from './form.module.scss';

export const Form = () => {
    const schema = yup
        .object({
            firstName: yup.string().required(),
            lastName: yup.string().required(),
            email: yup.string().email('must be a valid email').required(),
            phone: yup.string(),
            company: yup.string().required(),
            subject: yup.string().required(),
            questions: yup.string().required(),
        })
        .required();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    async function callApi(data) {
        const response = await fetch('/api/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error('Registration failed');
        }

        const res = await response.json();
        return res;
    }

    async function handleSubmitFunction(data) {
        const toastifyConfig = {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        }

        try {
            console.log(JSON.stringify(data));

            const response = await callApi(data);
            if (response === 'success') {
                toast.info('Your info is submitted, we will contact you in 24 hours. Thanks!', toastifyConfig);
                reset();
            } else {
                toast.error('Some error happens, please retry!', toastifyConfig);
            }
            return;
        } catch (error) {
            toast.error(`Some error happens, please retry!`, toastifyConfig);
        }
    }

    return (
        <form className={style.form} onSubmit={handleSubmit((data) => handleSubmitFunction(data))}>
            <div className={style.formLineItemTwoColumn}>
                <div className={style.formItemTitle}>First name*</div>

                <input
                    className={style.formInput}
                    {...register('firstName', { required: true })}
                    style={{
                        backgroundColor: errors['firstName'] ? '#FFEFEF' : null,
                        borderColor: errors['firstName'] ? '#FF2929' : null,
                    }}
                />
                {errors.firstName && <div className={style.errorMessage}>Please input your first name.</div>}
            </div>

            <div className={style.formLineItemTwoColumn}>
                <div className={style.formItemTitle}>Last name*</div>

                <input
                    className={style.formInput}
                    {...register('lastName', { required: true })}
                    style={{
                        backgroundColor: errors['lastName'] ? '#FFEFEF' : null,
                        borderColor: errors['lastName'] ? '#FF2929' : null,
                    }}
                />
                {errors.lastName && <div className={style.errorMessage}>Please input your last name.</div>}
            </div>

            <div className={style.formLineItemTwoColumn}>
                <div className={style.formItemTitle}>Email*</div>

                <input
                    className={style.formInput}
                    {...register('email', { required: true })}
                    style={{
                        backgroundColor: errors['email'] ? '#FFEFEF' : null,
                        borderColor: errors['email'] ? '#FF2929' : null,
                    }}
                />
                {errors.email && <div className={style.errorMessage}>Please input a valid email.</div>}
            </div>
            <div className={style.formLineItemTwoColumn}>
                <div className={style.formItemTitle}>Phone</div>

                <input
                    className={style.formInput}
                    {...register('phone', { required: false })}
                    style={{
                        backgroundColor: errors['phone'] ? '#FFEFEF' : null,
                        borderColor: errors['phone'] ? '#FF2929' : null,
                    }}
                />
                {errors.phone && <div className={style.errorMessage}>Please input your phone.</div>}
            </div>

            <div className={style.formLineItemTwoColumn}>
                <div className={style.formItemTitle}>Company Name*</div>

                <input
                    className={style.formInput}
                    {...register('company', { required: true })}
                    style={{
                        backgroundColor: errors['company'] ? '#FFEFEF' : null,
                        borderColor: errors['company'] ? '#FF2929' : null,
                    }}
                />
                {errors.company && <div className={style.errorMessage}>Please input your company.</div>}
            </div>
            <div className={style.formLineItemTwoColumn}>
                <div className={style.formItemTitle}>Subject*</div>

                <input
                    className={style.formInput}
                    {...register('subject', { required: true })}
                    style={{
                        backgroundColor: errors['subject'] ? '#FFEFEF' : null,
                        borderColor: errors['subject'] ? '#FF2929' : null,
                    }}
                />
                {errors.subject && <div className={style.errorMessage}>Please input subject.</div>}
            </div>

            <div className={style.formLineItemOneColumn}>
                <div className={style.formItemTitle}>Questions*</div>

                <textarea
                    className={style.formTextArea}
                    {...register('questions', { required: true })}
                    style={{
                        backgroundColor: errors['questions'] ? '#FFEFEF' : null,
                        borderColor: errors['questions'] ? '#FF2929' : null,
                    }}
                />
                {errors.questions && <div className={style.errorMessage}>Please input questions.</div>}
            </div>

            <div className={style.formLineItemOneColumn}>
                <input type="submit" value="SEND" className={style.formButton}></input>
            </div>

            <ToastContainer></ToastContainer>
        </form>
    );
};
